import type WebModel from '../../models/WebModel'
import type Blocklist from '../../blocklist/Blocklist'

export const IndexExchange = {
  init({ indexExchange }: WebModel, { all }: Blocklist) {
    if (!indexExchange || all) {
      return
    }
    setupHeadertagSpoof()
  }
}

function setupHeadertagSpoof() {
  if (!window.headertag) {
    window.headertag = {}
  }

  // We're spoofing the only function we needed out of IX's Identity Library in order to save ~72kb.
  // It's returning the same data their function provided, but getting it from the data the Prebid's
  // usersync integrations put into localStorage.
  window.headertag.getIdentityInfo = () => {
    const liverampId = window.localStorage.getItem('idl_env')
    const unifiedDataString = window.localStorage.getItem('_unifiedId')
    const merkleDataString = window.localStorage.getItem('merkle_id')

    // This is where the IXWrapper was storing the same usersync id.  We'll fallback to this
    // if the prebid location is empty.
    const ixWrapperLiveRampIp = window.localStorage.getItem(
      'IXWRAPPERLiveRampIp'
    )
    const ixWrapperAdserverOrgIp = window.localStorage.getItem(
      'IXWRAPPERAdserverOrgIp'
    )
    const ixWrapperMerkleIp = window.localStorage.getItem(
      'IXWRAPPERMerkleIp'
    ) as string

    // JSON data stored as `encodeURIComponent` string
    const merkleData = JSON.parse(
      decodeURIComponent(merkleDataString || ixWrapperMerkleIp || '{}')
    )

    const unifiedData = JSON.parse(
      decodeURIComponent(unifiedDataString || ixWrapperAdserverOrgIp || '{}')
    )

    const unifiedUids: any[] = []

    // I don't know why this data is structured like this, I'm just copying the
    // output from IndexExchanges's `headertag.getIdentityInfo()`
    for (const name in unifiedData) {
      unifiedUids.push({
        id: unifiedData[name],
        ext: {
          rtiPartner: name
        }
      })
    }

    return {
      AdserverOrgIp: {
        data: {
          source: 'adserver.org',
          uids: unifiedUids
        },
        responsePending: false
      },
      LiveRampIp: {
        data: {
          source: 'liveramp.com',
          uids: [
            {
              id: liverampId || ixWrapperLiveRampIp,
              ext: {
                rtiPartner: 'idl'
              }
            }
          ]
        },
        responsePending: false
      },
      MerkleIp: {
        data: {
          source: 'merkleinc.com',
          uids: [
            {
              id: merkleData?.pam_id?.id,
              ext: {
                enc: 0
              }
            }
          ]
        },
        responsePending: false
      }
    }
  }
}
